/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import axios from 'axios';
import { baseURL } from '../constants';
import { authHeader, history, RefreshHeader } from '../redux/helper';

async function RefreshToken() {
    try {
        if (localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            const data = await axios.post(`${baseURL}/admin-user/refresh-token`, { username: user.profile.email, refresh_token: user.refresh_token }, {
                headers: RefreshHeader(),
            });
            const duplicate = user;
            duplicate.access_token = data.data.data.access_token;
            localStorage.setItem('user', JSON.stringify(duplicate));
            return { error: false, data: data.data.data, refresh: true };
        }
    } catch (error) {
        return { error: true, message: 'Something Wrong' };
    }
}

async function login(email, password) {
    let payload = {
        username: email,
        password,
    };
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}/admin-user/sign-in`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function VerifyOtp(email, otp, session) {
    let payload = {
        username: email,
        otp,
        session,
    };
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}/admin-user/verify-otp`, payload);
        localStorage.setItem('user', JSON.stringify(data.data.data));

        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function resendOtp(email, session) {
    let payload = {
        username: email,
        session,
    };
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}/admin-user/resend-otp`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
function logout() {
    localStorage.removeItem('user');
    history.push('/');
    window.location.reload();
}

async function getManagers() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/managers`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getthreepl() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/3pls`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getTerritory() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/territories`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getProducts() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/categories`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function createUser(body) {
    try {
        const newBody = body;
        newBody.last_name = body.last_name === '' ? ' ' : body.last_name;
        const data = await axios.post(`${baseURL}/admin-user/create`, newBody, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UsersList(page, searchValue, filterValue, sort) {
    let data;
    try {
        if (filterValue === '' || filterValue === undefined) {
            if (page) {
                data = await axios.get(`${baseURL}/admin-user/list?page=${page}&limit=8${searchValue === '' ? `&sort=${sort} ` : `&search=${encodeURIComponent(searchValue.toLowerCase())}`}`, { headers: authHeader() });
            }
        } else {
            data = await axios.get(`${baseURL}/admin-user/list?page=${page}&limit=8${searchValue === '' ? `&sort=${sort} ` : `&search=${encodeURIComponent(searchValue.toLowerCase())}`}&${filterValue.substring(1)}&sort=${sort}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        await RefreshToken();
        // if (error.response.status === 401) {
        //     logout();
        // }
        return { error: true, message: error.message, refresh: true };
    }
}
async function handleExport(searchValue, filterValue, sort, sortKey) {
    let data;

    try {
        if (filterValue === '' || filterValue === undefined) {
            if (searchValue === '') {
                data = await axios.get(`${sortKey === 'admin-user/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/admin-user/`}${sortKey}${searchValue === '' ? `?sort=${sort} ` : `?search=${searchValue.toLowerCase()}`}`, { headers: authHeader() });
            } else {
                data = await axios.get(`${sortKey === 'admin-user/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/admin-user/`}${sortKey}${searchValue === '' ? `&sort=${sort} ` : `&search=${searchValue.toLowerCase()}`}`, { headers: authHeader() });
            }
        } else {
            data = await axios.get(`${sortKey === 'admin-user/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/admin-user/`}${sortKey}?sort=${sort}${filterValue}${searchValue === '' ? '' : `&search=${encodeURIComponent(searchValue.toLowerCase())}`}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
async function updateAdminUser(body, email) {
    try {
        const newBody = body;
        newBody.last_name = body.last_name === '' ? ' ' : body.last_name;
        const data = await axios.patch(`${baseURL}/admin-user/update/${email}`, newBody, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function ResetPassword(email) {
    try {
        const data = await axios.post(`${baseURL}/admin-user/reset/password/${email}`, {}, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function updatePassword(body) {
    try {
        const data = await axios.post(`${baseURL}/admin-user/update-new-password`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function ResetParticularUser(body) {
    try {
        const data = await axios.post(`${baseURL}/admin-user/password-reset`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function UserActiveOrDeactive(body, email) {
    try {
        const data = await axios.patch(`${baseURL}/admin-user/update/${email}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function UserActiveOrDeactivateAccount(body, email) {
    try {
        const data = await axios.patch(`${baseURL}/admin-user/${body.admin_status === '1' ? 'activate' : 'deactivate'}/${email}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response };
    }
}
async function getAdminDetail(email) {
    try {
        const data = await axios.get(`${baseURL}/admin-user/get/${email}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function getAdminDetailWithDistributors() {
    try {
        const { email } = JSON.parse(localStorage.getItem('user')).profile;
        const data = await axios.get(`${baseURL}/admin-user/get-sql/${email}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function appVersion(body) {
    let payload = body;
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post('https://hmfmozn8fj.execute-api.ap-south-1.amazonaws.com/dev/list', payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

export const userService = {
    appVersion,
    login,
    logout,
    VerifyOtp,
    resendOtp,
    getManagers,
    createUser,
    UsersList,
    updateAdminUser,
    ResetPassword,
    updatePassword,
    ResetParticularUser,
    getthreepl,
    getTerritory,
    getProducts,
    UserActiveOrDeactive,
    getAdminDetail,
    UserActiveOrDeactivateAccount,
    handleExport,
    RefreshToken,
    getAdminDetailWithDistributors,
};
